import m from "../../es2015/lang/nl_NL";
window.am4lang_nl_NL = m;


//////////////////
// WEBPACK FOOTER
// ./lang/nl_NL.js
// module id = null
// module chunks = 